import React from "react";

const StoriesLoader = (props) => (
  <img src="images/stories-loading.gif"/>
);

export default StoriesLoader;
